import Button, * as Btn from '@lib/components/Button';
import CheckBox from '@lib/components/CheckBox';
import ErrorMessage from '@lib/components/ErrorMessage';
import InputText, * as IInputText from '@lib/components/InputText';
import { isEmailValid, PASSWORD_SIZE } from '@lib/util/util';
import { LoginProps } from 'containers/Login';
import * as React from 'react';
import './Login.css';


interface ILoginState {
  login: string;
  isLoginError: boolean;
  password: string;
  isPasswordError: boolean;
  rememberMe: boolean;
  volume: number;
}

// declare var device: any;


class Login extends React.Component<LoginProps, ILoginState> {


  public constructor(props: LoginProps) {

    super(props);
    this.state = {
      isLoginError: false, isPasswordError: false, login: this.props.login, password: this.props.password,
      rememberMe: this.props.rememberMe, volume: 0
    };
  }


  /**
   * Fired when user clicks on "Remember Me" checkbox
   * @param state 
   * @param event 
   */
  public onRememberClick(state: ILoginState, event: React.MouseEvent<HTMLDivElement>) {
    this.setState({ rememberMe: !this.state.rememberMe });
  }

  /**
   * Fired when user clicks on "Login" button
   * @param state 
   * @param event 
   */
  public onLoginClick(state: ILoginState, event: React.MouseEvent<HTMLDivElement>) {
    // Check values
    const isLoginError = !isEmailValid(this.state.login);
    const isPasswordError = this.state.password.length < PASSWORD_SIZE;

    this.setState({ isLoginError, isPasswordError });

    if (isLoginError || isPasswordError) {
      return;
    }
    this.props.onLogin(this.state.login, this.state.password, this.state.rememberMe);
  }

  /**
   * Fired when user clicks on "Register" button
   * @param state 
   * @param event 
   */
  public onRegisterClick(state: ILoginState, event: React.MouseEvent<HTMLDivElement>) {
    this.props.onRegister();
  }

  /**
   * Fired when user clicks on "Lost Password" button
   * @param state 
   * @param event 
   */
  public onLostPasswordClick(state: ILoginState, event: React.MouseEvent<HTMLDivElement>) {
    this.props.onLostPassword();
  }



  /**
   * Fired when user change login input field
   * Logins are lower cased to prevent future login error...
   * @param state 
   * @param event 
   */
  public onChangeLogin(state: ILoginState, event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ login: event.currentTarget.value.toLowerCase(), isLoginError: this.state.isLoginError && !isEmailValid(event.currentTarget.value) });
  }

  /**
   * Fired when user change password input field
   * @param state 
   * @param event 
   */
  public onChangePassword(state: ILoginState, event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ password: event.currentTarget.value, isPasswordError: this.state.isPasswordError && event.currentTarget.value.length < PASSWORD_SIZE });
  }

  public handleOnChange = (value: number) => {
    this.setState({
      volume: value
    })
  }

  public render() {

    const i18n = this.props.i18n;


    return (
      <div className="login" style={{
        alignItems: 'center', display: "flex", flexDirection: "column",
        justifyContent: 'center'
      }}>
        <div className="logo" />
        <InputText icon={IInputText.ICO_USER_CIRCLE} type="email" maxLength={100} required={true} name={i18n.Login.email} id="login" isError={this.state.isLoginError} error={i18n.Common.errors.email} value={this.state.login} onChange={this.onChangeLogin.bind(this, this.state)} />
        <InputText icon={IInputText.ICO_KEY} type="password" required={true} name={i18n.Login.password} id="pass" isError={this.state.isPasswordError} value={this.state.password} error={i18n.Common.errors.password} onChange={this.onChangePassword.bind(this, this.state)} />
        <br />
        <CheckBox
          checked={this.state.rememberMe} label={i18n.Login.rememberMe} onClick={this.onRememberClick.bind(this, this.state)} />
        <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />
        <Button label={i18n.Login.login} type={Btn.BTN_TYPE_LARGE} onClick={this.onLoginClick.bind(this, this.state)} />
        <div className="lostpassword">
          <label onClick={this.onLostPasswordClick.bind(this, this.state)}>{i18n.Login.lostPassword}</label>
        </div>
        <div className="register">
          <label>{this.props.i18n.Login.notYetMemeber}</label>
          <label onClick={this.onRegisterClick.bind(this, this.state)}>{i18n.Login.register}</label>
        </div>
      </div>
    );
  }
}


export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.tsx